// The one breakpoint the clock cares about.
//
// The legacy views asked MUI's useMediaQuery(theme.breakpoints.down("sm")) and
// drew a dialog with a wheel on a phone and a floating panel on a desktop.
// The query is the one MUI builds for down("sm"), so that this and the
// screens that ask MUI directly never disagree at 600px.

import { useSyncExternalStore } from "react";

const QUERY = "(max-width:599.95px)";

function subscribe(onChange: () => void) {
  const mql = window.matchMedia(QUERY);
  mql.addEventListener("change", onChange);
  return () => mql.removeEventListener("change", onChange);
}

function read() {
  return window.matchMedia(QUERY).matches;
}

/** useBelowSm is true on a phone-sized viewport. */
export function useBelowSm(): boolean {
  return useSyncExternalStore(subscribe, read, () => false);
}
